import React from 'react';

const OptionsContainer = ({
  mapValue,
  optionsArr,
  generateQuestion,
  scoreIncrement,
  scoreDecrement,
}) => {
  const handleOptionClick = (evt) => {
    evt.preventDefault();
    let optionClickValue = evt.target.innerText;
    // console.log(optionClickValue);
    checkOptionValue(optionClickValue);
  };
  // Checks if correct or not
  const checkOptionValue = (value) => {
    if (value === mapValue) {
      // console.log('correct');
      generateQuestion();
      scoreIncrement();
    } else {
      // console.log('wrong selected');
      scoreDecrement();
      generateQuestion();
    }
  };
  return (
    <div className='options-container'>
      {optionsArr.map((optionValue, index) => {
        return (
          <div
            className='option-single'
            key={index}
            onClick={(evt) => handleOptionClick(evt)}
          >
            <span>{optionValue}</span>
          </div>
        );
      })}
    </div>
  );
};

export default OptionsContainer;
